module.exports = __webpack_public_path__ + "img/case-education.c1fca0f8.png";